export default __webpack_public_path__ + "static/phone-white-spanish-970ce8edc3074435c81ca101ede8019b.gif";